import {
  /* oxlint-disable-next-line no-restricted-imports */
  render as rtlRender,
  type RenderOptions,
  type RenderResult,
} from '@testing-library/react';
import { type ReactElement, type PropsWithChildren } from 'react';
import { IntlProvider } from 'react-intl';
import { vi } from 'vitest';

// Vitest-compatible matchMedia mock
const pristineMatchMedia = window.matchMedia;

export function setupMatchMediaMock(isMatching: boolean = false) {
  Object.defineProperty(window, 'matchMedia', {
    writable: true,
    value: vi.fn().mockImplementation((query) => ({
      matches: isMatching,
      media: query,
      onchange: null,
      addListener: vi.fn(), // Deprecated
      removeListener: vi.fn(), // Deprecated
      addEventListener: vi.fn(),
      removeEventListener: vi.fn(),
      dispatchEvent: vi.fn(),
    })),
  });
}

export function clearMatchMediaMock() {
  window.matchMedia = pristineMatchMedia;
}

// Custom render with IntlProvider (same as components-testing/jest/custom-render.tsx)
const AllProviders = ({
  children,
  locale = 'en',
  timeZone = 'UTC',
}: PropsWithChildren<{ locale?: string; timeZone?: string }>) => {
  return (
    <IntlProvider locale={locale} timeZone={timeZone}>
      {children}
    </IntlProvider>
  );
};

export function render(
  ui: ReactElement,
  {
    locale = 'en',
    timeZone = 'UTC',
    ...renderOptions
  }: { locale?: string; timeZone?: string } & Omit<
    RenderOptions,
    'queries'
  > = {},
): RenderResult {
  return rtlRender(ui, {
    wrapper: ({ children }) => (
      <AllProviders locale={locale} timeZone={timeZone}>
        {children}
      </AllProviders>
    ),
    ...renderOptions,
  });
}
